var exports = {
  "a": "Box__P5bEXs",
  "w": "Box_1__ky_4QH",
};

module.exports = exports;
